import React, { Suspense } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { Spinner } from 'reactstrap'

import AppNavbar from './AppNavbar'

const PageLoadingFallback = () => (
  <div className="d-flex flex-fill justify-content-center align-items-center">
    <Spinner color="secondary" />
  </div>
)

const ApplicationLayout = ({ children, currentTheme }) => {
  const themeClass = currentTheme !== 'default' ? `theme-${currentTheme}` : ''

  return (
    <div className={`d-flex flex-column flex-fill ${themeClass}`.trim()}>
      <AppNavbar />
      <Suspense fallback={<PageLoadingFallback />}>
        {children}
      </Suspense>
    </div>
  )
}

ApplicationLayout.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element
  ]).isRequired,
  currentTheme: PropTypes.string.isRequired
}

const mapStateToProps = ({
  theme: {
    current: currentTheme
  }
}) => ({
  currentTheme
})

export default connect(mapStateToProps)(ApplicationLayout)
